export default __webpack_public_path__ + "static/blob8-cad9f8472a8f431b08b2d071d04804f2.svg";